<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('range')}" id="range"
					formControlName="range" placeholder="">
				<label for="range">Range</label>
			</div>
			<p *ngIf="showError('range')" class="text-danger">
				<span *ngIf="f.range.errors?.incorrect">
					{{customError.range}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select id="operator" [items]="operatorList" bindLabel="name" bindValue="id" [clearable]="true"
				placeholder="Operator" formControlName="operator" [multiple]="false" appearance="outline">
			</ng-select>
			<p *ngIf="showError('operator')" class="text-danger">
				<span *ngIf="f.operator.errors?.incorrect">
					{{customError.operator}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('value')}" id="value"
					formControlName="value" placeholder="">
				<label for="value">Value</label>
			</div>
			<p *ngIf="showError('value')" class="text-danger">
				<span *ngIf="f.value.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.value.errors?.incorrect">
					{{customError.value}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('text')}" id="text"
					formControlName="text" placeholder="">
				<label for="text">Text*</label>
			</div>
			<p *ngIf="showError('text')" class="text-danger">
				<span *ngIf="f.text.errors?.required">
					Required
				</span>
				<span *ngIf="f.text.errors?.incorrect">
					{{customError.text}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select id="scale_id" [items]="scaleList" bindValue="scale_id" [clearable]="true" placeholder="Scale*"
				formControlName="scale_id" [multiple]="false" appearance="outline">
				<ng-template ng-label-tmp let-item="item">
					{{item.scale_name}}
				</ng-template>
				<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
					{{item.scale_name}}({{item.Cat_name}})
				</ng-template>
			</ng-select>
			<p *ngIf="showError('scale_id')" class="text-danger">
				<span *ngIf="f.scale_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.scale_id.errors?.incorrect">
					{{customError.scale_id}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select id="profile_id" [items]="profile_list" bindValue="id" [clearable]="true" placeholder="Profile*"
				formControlName="profile_id" [multiple]="false" appearance="outline">
				<ng-template ng-label-tmp let-item="item">
					{{item.name}} ({{item.age?'Below 18':'Above 18'}})
				</ng-template>
				<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
					{{item.name}} ({{item.age?'Below 18':'Above 18'}})
				</ng-template>
			</ng-select>
			<p *ngIf="showError('profile_id')" class="text-danger">
				<span *ngIf="f.profile_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.profile_id.errors?.incorrect">
					{{customError.profile_id}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>